<form class="dynamic-form" [formGroup]="form" novalidate>
  @for (fieldConfig of fieldConfigs; track fieldConfig) {
    <gk-form-renderer [fullFormConfig]="fieldConfigs" [fieldConfig]="fieldConfig" [formGroup]="form"
    [submitted]="submitted"></gk-form-renderer>
  }
</form>
